import ReactDOM from "react-dom";
const reactDOMInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function findDOMNode(instance) {
  return ReactDOM.findDOMNode ? ReactDOM.findDOMNode(instance) : reactDOMInternals.findDOMNode(instance);
}
export {
  findDOMNode
};
//# sourceMappingURL=react-dom.js.map